import {environment} from '../../../../environments/environment';

export const OAUTH_CLIENT_ID = environment.api.clientId;
export const OAUTH_CLIENT_SECRET = environment.api.clientSecret;
export const OAUTH_SCOPE = environment.api.clientScope;
export const OAUTH_GRANT_TYPE = environment.api.grantType;
